import { $t } from '@/i18n';
/* eslint-disable @typescript-eslint/naming-convention */
import { StreamParser } from '../ai-stream-parser/StreamParser';
import { set } from 'lodash';
import { PATH_PREFIX } from '@/config/constant';
import { getTraceIdHeaders, AI_MODULE_MAP } from '@/modules/ai/helper';
let openai = null;
function getOpenAiInstance(OpenAI, options) {
    let projectId = '';
    let env = 'dev';
    if (window?.RUNTIME_CONFIGS) {
        ({ projectId, env } = window.RUNTIME_CONFIGS);
    }
    else {
        const query = new URLSearchParams(window.location.search);
        projectId = query.get('projectId') || query.get('projectid') || '';
    }
    if (!projectId || !env)
        return;
    const clientOptions = {
        apiKey: '',
        baseURL: `${window.location.origin}${PATH_PREFIX}/api/xy/runtime/llm`,
        dangerouslyAllowBrowser: true,
        defaultHeaders: {
            'xy-project-id': projectId,
            'xy-env': env,
            ...getTraceIdHeaders(AI_MODULE_MAP.RUNTIME_AI_SDK),
        },
    };
    if (options?.apiKey)
        set(clientOptions, ['defaultHeaders', 'xy-ai-api-key'], options.apiKey);
    if (options?.baseURL)
        set(clientOptions, ['defaultHeaders', 'xy-ai-base-url'], options.baseURL);
    return new OpenAI(clientOptions);
}
/**
 * 异步加载 OpenAI 模块（优先从插件获取）
 */
async function initByImport(options) {
    const OpenAI = window?.OpenAI || (await import('openai')).default;
    window.OpenAI = OpenAI;
    openai = getOpenAiInstance(OpenAI, options);
}
/**
 * 同步加载 OpenAI 模块（只从插件获取）
 */
function initByPlugin() {
    const OpenAI = window?.OpenAI;
    if (OpenAI) {
        const config = window['internal:w-plugin-openai:config'];
        openai = getOpenAiInstance(OpenAI, config);
    }
}
export function getLLMInstance() {
    return new Proxy({}, {
        get(target, prop) {
            if (prop === 'init') {
                return (options) => initByImport(options);
            }
            if (prop === 'StreamParser') {
                return StreamParser;
            }
            if (!openai)
                initByPlugin();
            if (!openai)
                throw new Error($t('k_3a29b68c'));
            return openai[prop];
        },
    });
}
